import { render, staticRenderFns } from "./page-nature-sound.vue?vue&type=template&id=0d236820&"
import script from "./page-nature-sound.vue?vue&type=script&lang=ts&"
export * from "./page-nature-sound.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports